// Banner state for the three-way trust reconciliation shown on the Trust
// Accounting page.
//
// A genuine tie-out needs the client sub-ledgers, GL Trust Bank (1400), GL
// Trust Liability (2300) and the bank statement to ALL agree. The backend
// (ThreeWayTrustReconciliationView.compute) now checks the full pairwise
// set — previously it ran ledgers-vs-2300 and 1400-vs-bank as two
// independent two-way comparisons and never compared 1400 to 2300, so a
// discrepancy living between the two GL trust accounts (e.g. a payment
// misposted to 1400 a second time) passed as "in balance".
//
// Three visible states:
//   reconciled             → all four agree (green)
//   pending_bank_statement → GL and ledgers tie, no statement imported yet (amber)
//   out_of_balance         → a genuine disagreement, incl. GL 1400 ≠ GL 2300 (red)
export function threeWayReconciliationTone(differences) {
  const diff = differences || {};
  if (diff.is_reconciled) {
    return {
      state: 'reconciled',
      border: 'border-green-200 bg-green-50',
      text: 'text-green-800',
      label: ' — in balance',
    };
  }
  if (diff.gl_and_ledger_tie && !diff.bank_statement_available) {
    return {
      state: 'pending_bank_statement',
      border: 'border-amber-300 bg-amber-50',
      text: 'text-amber-800',
      label: ' — GL and ledgers tie; bank statement not imported',
    };
  }
  return {
    state: 'out_of_balance',
    border: 'border-red-300 bg-red-50',
    text: 'text-red-800',
    label: ' — OUT OF BALANCE',
  };
}
